import React from 'react'
import useCallApi from '../../utilities/axios'
import * as umServinceURL from './umServiceURL'
import { encryption } from '../../utilities/encryption'

export type FormProps = {
    passcode: string
    newPasscode: string
    confirmNewPasscode: string
}

export type ChangePasscodeProps = {
    userId: number
    passcode: string
    newPasscode: string
}

const usePreferencePasscode = () => {
    const callApi = useCallApi()

    const putPreferencesChangePasscode = async (param: ChangePasscodeProps) => {
        try {
            const { data } = await callApi.axiosPut<any>({
                url: `${umServinceURL.putPreferencesChangePasscode}/${param.userId}`,
                params: {
                    passcode: encryption(param.passcode),
                    newPasscode: encryption(param.newPasscode)
                }
            })
            return data
        } catch (error) {
            console.log('error', error)
        }
    }

    return {
        putPreferencesChangePasscode
    }
}

export default usePreferencePasscode
